var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReports01 = function SvgIconReports01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.71,
    y1: 97.21,
    x2: 74.12,
    y2: 25.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.39,
    y1: 97.54,
    x2: 74.43,
    y2: 25.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 21.1,
    y1: 119.87,
    x2: 95.92,
    y2: 47.87,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.83,51.37V6.25c0-1.15-.93-2.08-2.08-2.08C19.63,4.17,0,25.66,0,52.08s21.5,47.92,47.92,47.92c11.82,0,18.22-2.14,26.33-8.81.87-.72,1.01-2,.32-2.89l-28.73-36.93ZM47.92,95.83c-24.12,0-43.75-19.63-43.75-43.75S20.8,9.6,41.67,8.39v43.69c0,.46.15.91.44,1.28l27.9,35.87c-6.58,5.03-12.07,6.6-22.09,6.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.08,50h45.83c1.15,0,2.08-.93,2.08-2.08C100,21.5,78.5,0,52.08,0c-1.15,0-2.08.93-2.08,2.08v45.83c0,1.15.93,2.08,2.08,2.08ZM54.17,4.22c22.47,1.06,40.56,19.15,41.62,41.62h-41.62V4.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.92,54.17h-41.67c-.8,0-1.54.46-1.88,1.19-.35.73-.24,1.58.26,2.2l27.08,33.53c.36.45.9.73,1.47.77.05,0,.1,0,.15,0,.52,0,1.03-.2,1.42-.56,9.69-9.04,15.25-21.81,15.25-35.05,0-1.15-.93-2.08-2.08-2.08Z"
  })));
};
export default SvgIconReports01;